/**
 * The sections of the eSocial connection screen, in display order, as the
 * address names them in `?aba=`. The page that draws the strip and every link
 * that sends somebody to a section read the slugs from here, so the two cannot
 * spell a tab differently -- the same arrangement as
 * [`companyTabs`](./companyTabs.ts). The first is the default.
 */
export const ESOCIAL_TABS = {
  conexao: 'Conexão',
  portal: 'Portal eSocial',
} as const;

export type EsocialTab = keyof typeof ESOCIAL_TABS;

/** The tablist's accessible name. */
export const ESOCIAL_TABS_LABEL = 'Seções da conexão eSocial';
